import {
  AfterContentInit,
  Component,
  contentChildren,
  output
} from "@angular/core";
import { TabComponent } from "../tab/tab.component";

@Component({
  selector: "av-tab-group",
  templateUrl: "./tab-group.component.html",
  styleUrls: ["./tab-group.component.scss"],
  standalone: false,
})
export class TabGroupComponent implements AfterContentInit {
  readonly tabList = contentChildren(TabComponent);

  readonly selected = output<string>();

  ngAfterContentInit() {
    const activeTabs = this.tabs.filter((tab) => tab.active());

    if (activeTabs.length === 0 && this.tabs.length > 0) {
      this.select(this.tabs[0]);
    }
  }

  public setActiveTab(id: string) {
    const tab = this.tabs.find((t) => t.id() === id);
    if (tab) {
      this.select(tab);
    }
  }

  protected select(tab: TabComponent) {
    if (tab.disabled()) {
      return;
    }
    this.tabs.forEach((t) => t.active.set(false));
    tab.active.set(true);
    this.selected.emit(tab.id());
  }

  protected get tabs() {
    return this.tabList().filter((t) => t.visible());
  }
}
